// Enum representing the direction for a shipment.
export enum ShipmentDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}
